import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { usePageLoader } from '@/composables/ui/usePageLoader'


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePageLoader',
  setup(__props) {

const { isLoading } = usePageLoader()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["page-loader-wrapper", { 'page-loader--visible': _unref(isLoading) }]),
      "aria-hidden": "true"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "page-loader-bar" }, null, -1)
    ]), 2)
  ]))
}
}

})